import Draggable from "./interactions/Draggable.js";
import Clickable from "./interactions/Clickable.js";
import Group from "./interactions/Group.js";

import Error from "../utils/Error.js";

const Interactions = function Interactions() {
    let interactions = {};
    let default_interaction = null;
    let stack = [];
    let selected = null,
        passive = null;

    this.add_draggable = (options) => {
        if (options.name in interactions) {
            throw Error.build.exist(`redefining draggable ${options.name}`);
        }
        interactions[options.name] = new Draggable(options);
    };

    this.add_clickable = (options) => {
        if (options.name in interactions) {
            throw Error.build.exist(`redefining clickable ${options.name}`);
        }
        interactions[options.name] = new Clickable(options);
    };

    this.add_group = (options) => {
        if (options.name in interactions) {
            throw Error.build.exist(`redefining group ${options.name}`);
        }
        let group_interactions = [];
        for (let interaction_name of options.interactions) {
            group_interactions.push(interactions[interaction_name]);
        }
        options.interactions = group_interactions;
        interactions[options.name] = new Group(options);
    };

    this.add_to_group = ({interaction_name, group_name}) => {
        if (!(group_name in interactions)) {
            throw Error.build.exist(`group ${group_name} doesn't exists`);
        }
        let group = interactions[group_name];
        if (group.constructor.name !== "Group") {
            throw Error.build.invalid(`${group_name} is not a group`);
        }
        if (!(interaction_name in interactions)) {
            throw Error.build.exist(`interaction ${interaction_name} doesn't exists`);
        }
        let interaction = interactions[interaction_name];
        group.add_interaction(interaction);
    };

    this.set_default = ({name, enable, disable}) => {
        default_interaction = {name, enable, disable};
        interactions[name] = default_interaction;
        if (stack.length === 0) {
            default_interaction.enable();
        }
    };

    this.remove = (interaction_name) => {
        delete interactions[interaction_name];
    };

    this.passive_enable = (name) => {
        if (passive !== null) {
            passive.disable();
        }
        if (!(name in interactions)) {
            throw Error.build.noent(`interaction ${name} is not defined`);
        }
        passive = interactions[name];
        passive.enable();
    };

    this.passive_disable = (name) => {
        if (passive === null) {
            return;
        }
        if (name !== undefined && passive.name !== name) {
            return;
        }
        passive.disable();
        passive = null;
    };

    this.enable = (name) => {
        if (selected !== null) {
            selected.disable();
            stack.push(selected);
        }
        if (!(name in interactions)) {
            throw Error.build.noent(`interaction ${name} is not defined`);
        }
        selected = interactions[name];
        selected.enable();
    };

    this.disable = (name) => {
        if (selected === null) {
            return;
        }
        if (name !== undefined && selected.name !== name) {
            return;
        }
        selected.disable();
        selected = stack.pop();
        if (selected === undefined) {
            if (default_interaction !== null) {
                selected = default_interaction;
                selected.enable();
            } else {
                selected = null;
            }
        } else {
            selected.enable();
        }
    };

    this.enabled = (name) => {
        if (name === undefined) {
            return selected !== null;
        }
        return interactions[name].enabled;
    };
};

export default Interactions;
